'use strict';

angular.module('amexReconciliationApp').filter('userPreferenceCurrencyFormat',
  function currencyFormatter($filter, CurrencyService) {
    return function (amount, currencyFormat) {

      var periodAmount = $filter('currency')(amount,'');
      
      if (currencyFormat == 'COMMA') {
        return CurrencyService.switchCommasAndPeriods(periodAmount);
      } else {
        return periodAmount;
      }
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/filters/userPreferenceCurrencyFormat.js
// module id = 562
// module chunks = 0